// Страница «Индекс по адресу»

import "../index-by-address/demo";
import scrollTo from "../components/scroll-to";
import paymentBlock from "../payments/payment-block";

import calculator from "../clean/calculator";

if (window.DA.user.isAuthenticated) {
    import("../profiles/invoice").then(() => {
        calculator.Calculator(document.querySelector(".js-calculator"));
        paymentBlock.init();
        paymentBlock.initWithInput();
    });
}

scrollTo.init();
